import { trackEvent } from './analytics';

export type AuthAnalyticsSurface =
  | 'login'
  | 'register'
  | 'checkout_modal'
  | 'editor_modal'
  | 'one_tap'
  | 'seller_program'
  | 'creator_program'
  | 'account_settings'
  | 'seller_settings'
  | 'creator_settings'
  | 'auth_prompt';

export type AuthAnalyticsMethod = 'google' | 'google_one_tap' | 'email';

type AuthEventPayload = {
  surface?: AuthAnalyticsSurface;
  method?: AuthAnalyticsMethod;
  intent?: 'login' | 'register' | 'link';
  reason?: string;
};

export function trackAuthGoogleClick(
  surface: AuthAnalyticsSurface,
  intent: 'login' | 'register' | 'link' = 'login',
): void {
  trackEvent('auth.google.click', { surface, intent, method: 'google' });
}

export function trackAuthGoogleSuccess(
  surface: AuthAnalyticsSurface,
  intent: 'login' | 'register' | 'link' = 'login',
): void {
  trackEvent('auth.google.success', { surface, intent, method: 'google' });
}

export function trackAuthGoogleFail(
  surface: AuthAnalyticsSurface,
  reason: string,
  intent: 'login' | 'register' | 'link' = 'login',
): void {
  trackEvent('auth.google.fail', { surface, intent, method: 'google', reason });
}

export function trackAuthOneTapPrompt(surface: AuthAnalyticsSurface = 'one_tap'): void {
  trackEvent('auth.one_tap.prompt', { surface, method: 'google_one_tap' });
}

export function trackAuthOneTapAccept(surface: AuthAnalyticsSurface = 'one_tap'): void {
  trackEvent('auth.one_tap.accept', { surface, method: 'google_one_tap' });
}

export function trackAuthOneTapDismiss(surface: AuthAnalyticsSurface = 'one_tap'): void {
  trackEvent('auth.one_tap.dismiss', { surface, method: 'google_one_tap' });
}

export function trackAuthOneTapFail(reason: string): void {
  trackEvent('auth.one_tap.fail', { surface: 'one_tap', method: 'google_one_tap', reason });
}

export function trackAuthLinkAction(
  action: 'view' | 'link_click' | 'link_success' | 'unlink' | 'set_password',
  payload?: AuthEventPayload,
): void {
  trackEvent(`auth.linked_accounts.${action}` as Parameters<typeof trackEvent>[0], payload);
}
